import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../../utils";
import { ReactComponent as ViewIcon } from "../../../Icons/totalView.svg";
import { ReactComponent as HeartIcon } from "../../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../../Icons/heartSelect.svg";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PdfWhiteIcon } from "../../../Icons/pdfWhiteIcon.svg";
import { fetchAttachmentURL, getQuestionDraftData, markUnmarkFavourite } from "../../../API/api";
import { ReactComponent as InternalIcon } from "../../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../../Icons/download.svg";
import Button2 from "../../Button2/Button2";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import TooltipComp from "../../ToolTip/TooltipComp";
import { Home_PAGE_URL } from "../../../Router/routerUrl";
import { bindActionCreators } from "redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Actions } from "../../../Action";
import { CURRENT_ROLE } from "../../../API/url";


export default function QuestionBox({ question }) {
  const searchState = useSelector((state) => state.search);
  const [isFavorite, setFavorite] = useState(question.favourite);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [hovered, setIsHovered] = useState(false)
  const editorState = useSelector((state) => state.editor);
    const currentPath = useLocation();
const userState = useSelector((state) => state.user);

  // const {recommendData,preservePreviousRecommendData,} = bindActionCreators(Actions,dispatch)
  const { recommendData, preservePreviousRecommendData, getkeyTagPayload,filteredOrigSearchData, advanceFilterModalToggle, getSelectedQuestion, markedTrendingData, markedAnsweredData, markedFavData, markedSharedByData, markedSharedWithData, updateKeyTagData, questionDataForEditor, updateAnswerTextForEditor, updateSubmissionTypeForEditor, updateAttachmentForEditor, updateCheckBoxValForEditor, filteringSearchData, getSeekerAttachment } =
    bindActionCreators(Actions, dispatch);
  const onCLickFavorite = (key, flag) => {
    
    markUnmarkFavourite(key.questionUuid).then((res) => {
      if (res === undefined) return;
      setFavorite(flag);
    });
  };
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };
  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
    cursor: hovered ? 'pointer' : 'default',
    textDecoration:hovered ? 'underline' : 'none'
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };
  const confidenceStyles1 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #F59B00",
    borderRadius: "6px",
    backgroundColor: "#F59B00",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };
  const confidenceStyles2 = {
    // width:'52px',
    height: "36px",
    border: "1px solid #00A3FF",
    borderRadius: "6px",
    backgroundColor: "#00A3FF",
    color: "#FFFFFF",
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "6px 12px 6px 12px",
  };

  const generatingRelatedQ = (data) =>{
    if(data.text === undefined){
      data.text = data.questionText;
    }
    getkeyTagPayload(null)
    if(!data.reusableThreadQA){
      let payload ={
        data:{
          id:data.questionUuid,
        text:data.text
        }
      }
      preservePreviousRecommendData([])
      recommendData(payload);
      navigate(`${Home_PAGE_URL}recommend`);
    }else if(data.reusableThreadQA){
      if(data.status === 'accepted'){
        let payload ={
          data:{
            id:data.questionUuid,
          text:data.text
          }
        }
        preservePreviousRecommendData([])
        recommendData(payload);
        navigate(`${Home_PAGE_URL}recommend`);
      }
    }

  }
const isAnsweredByMe = (arr) => {
    let id = ""
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        updateCheckBoxValForEditor({ flag: obj.internal, key: "internal" });
        updateCheckBoxValForEditor({ flag: obj.privacy, key: "isUpdateKB" });
        id = obj.answerUuid;
      }
    })
    return id;
  }

  const isAnsweredByMeAttachment = (arr) => {
    // console.log("answers", arr)
    let text = []
    arr.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        text = obj.attachments;
      }
    })
    return text;
  }
  const convertStringToEpoch = (dt) => {
    let date = Date.parse(dt);
    return date;
  }
 
  const appendInlineImageInText = async (arr) =>{
    let newArr = await arr.filter(obj=>{
      if(obj.expertUuid === userState.geoAttributes.userId){
        if(obj.inlineImages.length > 0){
          for (let i = 0; i < obj.inlineImages.length; ++i) {
            let pld= {name: obj.inlineImages[i]}
            fetchAttachmentURL(pld).then(res=>{
              if (res===undefined) return;
              if (obj.inlineImages[i].includes(".png")) {
              } else {
                let imgTag = `<img style='max-width:50%' src=${
                  res.data.data.src
                }></img>`;
  
                let replacedContent = obj.inlineImages[i];
                obj.answerCopy = obj.answerCopy.replaceAll(
                  replacedContent,
                  imgTag
                );
                updateAnswerTextForEditor(obj.answerCopy);
              }
            })
          }
        }
        
        return obj;
      }
    })
    updateAnswerTextForEditor(newArr.length === 0?"":newArr[0].answerCopy);
  }
  const editAnswer = () => {
    // console.log("question",question)
    let data = question;
    if (data.questionText === undefined) {
      data.questionText = data.text;
    }
    if (currentPath.pathname.includes('/search')) {
      data.questionUuid = data.origQuestionUuid;
    }
    if (data.seekerAttachments && data.seekerAttachments !== null) {
      getSeekerAttachment(data.seekerAttachments)
    }
    updateAttachmentForEditor(isAnsweredByMeAttachment(data.answersList))
    let isAnswerUuid = isAnsweredByMe(data.answersList);
    editorState.answerUuid = isAnsweredByMe(data.answersList);
    updateSubmissionTypeForEditor(isAnswerUuid === '' ? 'answer' : 'update');
    data.questionPostedTimestamp = data.questionPostedTimestamp === undefined ? data.postedTimestamp : data.questionPostedTimestamp;
    data.questionStatus = 'answered';
    data.questionPostedTimestamp = typeof (data.questionPostedTimestamp) === 'string' ? convertStringToEpoch(data.questionPostedTimestamp) : data.questionPostedTimestamp;
    questionDataForEditor(data);
    getQuestionDraftData(data.questionUuid).then(res => {
      if (res === undefined) return;
      if (res.data.data.length > 0) {
        updateAnswerTextForEditor(res.data.data[0].answer);
      } else {
        appendInlineImageInText(data.answersList);
      }
    })
    navigate('/expertHome/editor');
  }
  return (
    <>
      <div style={infoContainer}>
        <div style={dateInfoStyles} onMouseEnter={()=>setIsHovered(true)} onMouseLeave={()=>setIsHovered(false)}>
          <div style={textStyles} onClick={()=>generatingRelatedQ(question)}>
          {question.text}
        </div>
          <div style={infoContainer}>
            {
              (isFavorite ? (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                                    <TooltipComp title={"Favorite question"}>
                  
                  <HeartSelectedIcon
                    onClick={() => onCLickFavorite(question, false)}
                  />
                  </TooltipComp>
                </div>
              ) : (
                <div style={{ marginRight: "6px", cursor: "pointer" }}>
                                    <TooltipComp title={"Favorite question"}>
                  
                  <HeartIcon onClick={() => onCLickFavorite(question, true)} />
                    </TooltipComp>
                </div>
              ))}
               {question.isShowUpdateRequestWarning && <div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginRight:'5px', cursor:'pointer'}}></i></span></TooltipComp>
               </div>}
               {CURRENT_ROLE==='Expert'&&<div> <TooltipComp title={"Edit answer"}><i className="fa fa-edit" style={{fontSize:'20px', marginTop:'5px', color:'#ACB6C6', cursor:'pointer'}} onClick={()=>editAnswer()}></i></TooltipComp></div>}
          </div>
        </div>
      </div>
    </>
  );
}
